'use server'

export let products = [
    {
        "title": "Steyer Brand",
        "description": "Marca de óculos anti-luz azul",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4965/4965.png",
        "client": "Steyer Brand",
        "url": "https://links.parceirando.com.br/marketing/4965",
        "comission": "Fixado R$",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4965",
        "categories": [
            "Informática",
            "Moda e Acessórios",
            "Saúde"
        ],
        "Type": "Informática"
    },
    {
        "title": "lhshop",
        "description": "comissão de 2% do que vender sobre o faturamento ",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/003/821/193/themes/common/logo-497138060-1713674649-7be5d318ef903ccb7293e4b0bdce6f261713674649.png?0",
        "client": "lhshop",
        "url": "https://links.parceirando.com.br/marketing/5062",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/5062",
        "categories": [
            "Games",
            "Informática",
            "Outros"
        ],
        "Type": "Games"
    },
    {
        "title": "Centro de Compras Mix.Shop",
        "description": "Somos um grupo focado em ajudar pessoas que buscam oportunidades de empreender através da internet.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/620/456/themes/common/logo-1371025953-1714175295-eff728d5103c92ff6a0d8fcd00d9ce2c1714175295.png?0",
        "client": "Centro de Compras Mix.Shop",
        "url": "https://links.parceirando.com.br/marketing/4975",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4975",
        "categories": [
            "Cosméticos",
            "Entretenimento",
            "Informática",
            "Moda e Acessórios",
            "Perfumes",
            "Saúde",
            "Outros"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "Jets Outlet",
        "description": "Loja de departamentos",
        "image": "https://parceirando.s3.amazonaws.com/media/landing/404.webp",
        "client": "Jets Outlet",
        "url": "https://links.parceirando.com.br/marketing/4302",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4302",
        "categories": [
            "Cosméticos",
            "Games",
            "Infantil/Bebês",
            "Informática",
            "Moda e Acessórios",
            "Perfumes",
            "Pet",
            "Outros"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "L&L Sport Shop ",
        "description": "🚀 Junte-se ao Time de Afiliados da L&L Sport Shop! ⚽ Promova camisas de futebol tailandesas 1.1 de alta qualidade e ganhe comissões generosas. Oferecemos promoções irresistíveis como pague 2 e leve 3, 10% de desconto na primeira compra e 5% off no PIX. Com suporte dedicado e um painel de controle avançado, maximizar suas vendas nunca foi tão fácil. Inscreva-se agora e transforme sua paixão pelo futebol em lucro! 🔗 #AfiliadosLLSportShop #GanheComFutebol",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/003/877/175/themes/common/logo-501764133-1708790847-aebaf51b5ce6f30784e27f432afc455a1708790848.png?0",
        "client": "L&L Sport Shop ",
        "url": "https://links.parceirando.com.br/marketing/5037",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/5037",
        "categories": [
            "Entretenimento",
            "Moda e Acessórios",
            "Outros"
        ],
        "Type": "Entretenimento"
    },
    {
        "title": "Loja dos Variados",
        "description": "Loja especializada em vendas de produtos de giro rápido, com valores de atacado e excelentes margens de lucro.",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4867/4867.png",
        "client": "Loja dos Variados",
        "url": "https://links.parceirando.com.br/marketing/4867",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4867",
        "categories": [
            "Casas e Móveis",
            "Cosméticos",
            "Entretenimento",
            "Infantil/Bebês",
            "Moda e Acessórios",
            "Pet",
            "Saúde",
            "Outros"
        ],
        "Type": "Casas e Móveis"
    },
    {
        "title": "Demo Parceirando",
        "description": "Teste - gestão de afiliados Parceirando.",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/642/642.png",
        "client": "Demo Parceirando",
        "url": "https://links.parceirando.com.br/marketing/642",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/642",
        "categories": [
            "Entretenimento"
        ],
        "Type": "Entretenimento"
    },
    {
        "title": "Parolli",
        "description": "Roupas de treino para o público masculino adulto",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/001/539/716/themes/common/logo-1056997214-1708880601-a77e1b503731be482594ed43860805771708880601.png?0",
        "client": "Parolli",
        "url": "https://links.parceirando.com.br/marketing/3381",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/3381",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Versátil Glasses",
        "description": "Versátil glasses Óculos de sol",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/001/352/063/themes/common/logo-1600033787-1636427425-d711a5af59c48e8411a8de298c5d65d71636427425.png?0",
        "client": "Versátil Glasses",
        "url": "https://links.parceirando.com.br/marketing/2144",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/2144",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Natural Art",
        "description": "The natural art of surfing since seventy one.\r\nRespirando surf e propagando essa paixão através de produtos inovadores e de alta qualidade.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/002/427/817/themes/common/logo-1656402291-1666987635-bc670d15682ac759ae6b8840f85bb39a1666987636.png?0",
        "client": "Natural Art",
        "url": "https://links.parceirando.com.br/marketing/4576",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4576",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Yadez",
        "description": "Somos uma empresa especializada em curadoria de Semijoias. A qualidade das nossas Semijoias é uma de nossas principais prioridades. Selecionamos peças que utilizam materiais e técnicas de fabricação avançadas, garantindo a durabilidade e o acabamento impecável.\r\nA Yadez valoriza o atendimento ao cliente. Estamos empenhados em fornecer um excelente serviço, desde o momento da compra até a entrega para garantir a satisfação do cliente em todo o processo.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/227/679/themes/common/logo-1956911017-1709402672-cef25dde69fd015f6372dab2d77851101709402672.png?0",
        "client": "Yadez",
        "url": "https://links.parceirando.com.br/marketing/4873",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4873",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Atacado saia na moda",
        "description": "Somos uma loja online a compra é feita diretamente em nosso site https://www.atacadosaianamoda.com.br/ em tempo real você todos os modelos certinho e valores no atacado de cada peça. ",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/526/270/themes/common/logo-896287268-1716553077-65240b5e63818bf2be4a1909ae0fcf191716553077.png?0",
        "client": "Atacado saia na moda",
        "url": "https://links.parceirando.com.br/marketing/5072",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/5072",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Lite",
        "description": "Moda esportiva masculina",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4855/4855.png",
        "client": "Lite",
        "url": "https://links.parceirando.com.br/marketing/4855",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4855",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Milanni",
        "description": "Milanni: Afiliados sem estoque. Comissão até 20%. Suporte personalizado. Junte-se a nós!",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/309/254/themes/common/logo-1326008629-1712675131-8013d2e0123ad0a680f329a9b5f0ac011712675131.jpg?0",
        "client": "Milanni",
        "url": "https://links.parceirando.com.br/marketing/4933",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4933",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Radical Sports ",
        "description": "Acessórios Artigos Esportivos Vestuário Calçados",
        "image": "https://parceirando.s3.amazonaws.com/media/landing/404.webp",
        "client": "Radical Sports ",
        "url": "https://links.parceirando.com.br/marketing/702",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/702",
        "categories": [
            "Cosméticos",
            "Moda e Acessórios",
            "Perfumes",
            "Outros"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "M4wave",
        "description": "Torne-se um afiliado da maior marca de roupas inspiradas em animes e mangás do Brasil ",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/003/315/558/themes/common/logo-1393371298-1691699071-a68c716889abe562da68c4efe3d6ad9a1691699071.png?0",
        "client": "M4wave",
        "url": "https://links.parceirando.com.br/marketing/4426",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4426",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Mimos Secretos",
        "description": "Moda Feminina, Moda Intima e Moda Praia",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/937/312/themes/common/logo-2043078886-1569374133-6d15a957a1f094940ca035a97fec3deb1569374134.png?0",
        "client": "Mimos Secretos",
        "url": "https://links.parceirando.com.br/marketing/3775",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/3775",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "RIZZY",
        "description": "MODA PRAIA E FITNESS",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4689/4689.png",
        "client": "RIZZY",
        "url": "https://links.parceirando.com.br/marketing/4689",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4689",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Parlaeye",
        "description": "Autenticidade, proteção e estilo. \r\nOs óculos de sol que fazem você falar. ",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/003/791/322/themes/common/logo-1423880846-1697681053-d959706d8426718775525db508c566d01697681053.png?0",
        "client": "Parlaeye",
        "url": "https://links.parceirando.com.br/marketing/4897",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4897",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "W COMPANY",
        "description": "ALTA TAXA DE CONVERSÃO - Camisetas, Moletons e Acessórios Streetwear\r\nMatéria prima selecionada e sustentável com selo BCI (Better Cotton Initiative)\r\n5% OFF no PIX ou em até 12x",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/001/608/638/themes/common/logo-1800565396-1698816576-b712b44fa92ac03be34289732b96c3c21698816577.png?0",
        "client": "W COMPANY",
        "url": "https://links.parceirando.com.br/marketing/4735",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4735",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Public House",
        "description": "Vendemos uma variedade de roupas masculinas para usar como quiser. Seja em momentos casuais ou até formais.",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/001/485/189/themes/common/logo-265993833-1703164770-64aeb5a9976187702a119e19f32b67de1703164770.png?0",
        "client": "Public House",
        "url": "https://links.parceirando.com.br/marketing/1753",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/1753",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Saint Germain Brand",
        "description": "Ecommerce de relógios minimalistas. Há 3 anos no mercado.",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/1649/1649.png",
        "client": "Saint Germain Brand",
        "url": "https://links.parceirando.com.br/marketing/1649",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/1649",
        "categories": [
            "Moda e Acessórios",
            "Outros"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Not-me",
        "description": "Calçados Femininos com Estilo.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/003/698/021/themes/common/logo-249118484-1704805167-59e603fc4363d6b01be3a2e4443c06c91704805167.png?0",
        "client": "Not-me",
        "url": "https://links.parceirando.com.br/marketing/5047",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/5047",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Anna Engles Store",
        "description": "Moda e Acessórios Femininos",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/001/492/793/themes/common/logo-1297367632-1615922523-6b9d0a3f263f5f5d351eff649e8a43251615922524.png?0",
        "client": "Anna Engles Store",
        "url": "https://links.parceirando.com.br/marketing/5018",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/5018",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "AMÁLIAS",
        "description": "AMÁLIAS",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/001/083/868/themes/common/logo-282292999-1688389728-52d85995117b99b08ba7fdca53b173fb1688389728.png?0",
        "client": "AMÁLIAS",
        "url": "https://links.parceirando.com.br/marketing/3717",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/3717",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Stéfani Lopes",
        "description": "Marca de roupa feminina plus size, trabalhamos da numeração 42 até 60. Valorizamos a qualidade, desenvolvemos modelagens desenvolvidas para o corpo plus. ",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/002/601/155/themes/common/logo-1473752857-1701041114-113567e691dc3cdb3e689280cbf74f451701041115.png?0",
        "client": "Stéfani Lopes",
        "url": "https://links.parceirando.com.br/marketing/4329",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4329",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Ravenna Acessórios Finos",
        "description": "Comos uma loja de acessórios femininos, focada em bijuterias e folheados antenados com as últimas tendências de moda.",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/001/160/369/themes/common/logo-1737664375-1705697492-714ccdb73c26c94b260512c86dac68741705697492.png?0",
        "client": "Ravenna Acessórios Finos",
        "url": "https://links.parceirando.com.br/marketing/1710",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/1710",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "LALA BIQUINIS ",
        "description": "Somos uma loja especializada em moda praia.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/261/381/themes/common/logo-2119238415-1708609956-3e4443594aa6a84b4c586b16843a232e1708609956.png?0",
        "client": "LALA BIQUINIS ",
        "url": "https://links.parceirando.com.br/marketing/4830",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4830",
        "categories": [
            "Moda e Acessórios",
            "Outros"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "YOU NEED SPORTSWEAR",
        "description": "Moda fitness",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4336/4336.png",
        "client": "YOU NEED SPORTSWEAR",
        "url": "https://links.parceirando.com.br/marketing/4336",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4336",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Style Store",
        "description": "Moda Modesta - Vestidos ",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/002/188/364/themes/common/logo-2100261587-1688495645-d2299dce8119ac2f7323da0d2c9b7e3b1688495645.png?0",
        "client": "Style Store",
        "url": "https://links.parceirando.com.br/marketing/4686",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4686",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Follow Beachlife",
        "description": "Moda Praia e Fitwear",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/867/487/themes/common/logo-796802274-1710172084-651f067dc45774e32006bba19b6d847d1710172084.png?0",
        "client": "Follow Beachlife",
        "url": "https://links.parceirando.com.br/marketing/3570",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/3570",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Michele Martins de campos",
        "description": "Moldes de roupas",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/002/131/168/themes/common/logo-1095184997-1677871448-d1d462c16f20d43e0f9ea3439febb4281677871448.png?0",
        "client": "Michele Martins de campos",
        "url": "https://links.parceirando.com.br/marketing/4406",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4406",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Divina Elegância Semijoias",
        "description": "Semijoias finas e versáteis para mulheres práticas e estilosas.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/478/276/themes/common/logo-189167148-1711405954-2baf5c00caf05c2b2446439fe19ee1a71711405954.png?0",
        "client": "Divina Elegância Semijoias",
        "url": "https://links.parceirando.com.br/marketing/4761",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4761",
        "categories": [
            "Moda e Acessórios"
        ],
        "Type": "Moda e Acessórios"
    },
    {
        "title": "Gamers Coffee",
        "description": "Gamers Coffee Cafés Especiais, métodos de preparo e assessorios. ",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4402/4402.png",
        "client": "Gamers Coffee",
        "url": "https://links.parceirando.com.br/marketing/4402",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4402",
        "categories": [
            "Bebidas",
            "Outros"
        ],
        "Type": "Bebidas"
    },
    {
        "title": "Hiddra",
        "description": "A HIDDRA® é uma marca com foco em produtos para o transporte e consumo de bebidas, voltados para o usuário que busca qualidade e praticidade em seu dia-a-dia. A marca surgiu ao entender que adotar o uso de garrafas ou copos térmicos, é incorporado o compromisso diário com a saúde e bem-estar, além de ajudar na redução no uso de descartáveis.\r\nEspecializada em garrafas térmicas, oferecemos tamanhos variados - em cores vibrantes e modelos diversos.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/434/335/themes/common/logo-58130226-1715709572-5981e365b4221ef591ad916c6b95d2a41715709572.png?0",
        "client": "Hiddra",
        "url": "https://links.parceirando.com.br/marketing/5045",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/5045",
        "categories": [
            "Casas e Móveis",
            "Pet",
            "Saúde"
        ],
        "Type": "Casas e Móveis"
    },
    {
        "title": "Petala Beauty",
        "description": "Pétala Beauty Produtos de Beleza Ltda",
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBVC9ryNHZbdOCIvhmgIMmM3HaAkm4S7F7VSEJvHV8BKgL96_tbRMBYUNQU0WTlyQQ8ww&usqp=CAU",
        "client": "Petala Beauty",
        "url": "https://links.parceirando.com.br/marketing/3540",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/3540",
        "categories": [
            "Cosméticos",
            "Perfumes",
            "Saúde"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "Natureza em Saúde",
        "description": "Vitaminas e Suplementos Alimentares",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4237/4237.png",
        "client": "Natureza em Saúde",
        "url": "https://links.parceirando.com.br/marketing/4237",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4237",
        "categories": [
            "Saúde"
        ],
        "Type": "Saúde"
    },
    {
        "title": "Florais das Gerais",
        "description": "As essências florais são ''remédios'' produzidos a partir de flores silvestres e consistem em um método simples e natural de cura. Elas agem sobre o estado emocional das pessoas e animais e não somente sobre a doença física. ",
        "image": "https://a.imagem.app/bUuaeZ.jpeg",
        "client": "Florais das Gerais",
        "url": "https://links.parceirando.com.br/marketing/2768",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/2768",
        "categories": [
            "Pet",
            "Saúde",
            "Outros"
        ],
        "Type": "Pet"
    },
    {
        "title": "Plus Vitality",
        "description": "Nossa jornada teve início com uma dupla paixão: o compromisso com a saúde e o desejo de proporcionar às pessoas um estilo de vida pleno. Nossa empresa nasceu da união entre a medicina e a natureza, com o objetivo de oferecer suplementos naturais que capacitam as pessoas a descobrirem sua melhor versão.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/003/702/740/themes/common/logo-1469276702-1699559426-d81997cbdfd95529f49e256c54a1a5c01699559427.png?0",
        "client": "Plus Vitality",
        "url": "https://links.parceirando.com.br/marketing/4506",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4506",
        "categories": [
            "Saúde"
        ],
        "Type": "Saúde"
    },
    {
        "title": "EstriGold",
        "description": "Transformando vidas, EstriGold vem proporcionando a mudança na auto estima de muitas mulheres. Com o creme redutor de estrias e celulites e o creme clareador. A transformação que você merece!",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4642/4642.png",
        "client": "EstriGold",
        "url": "https://links.parceirando.com.br/marketing/4642",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4642",
        "categories": [
            "Cosméticos",
            "Perfumes",
            "Saúde"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "Container Bicicletas",
        "description": "Container Bicicletas tudo para sua bike. ",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4919/4919.png",
        "client": "Container Bicicletas",
        "url": "https://links.parceirando.com.br/marketing/4919",
        "comission": "Fixado R$",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4919",
        "categories": [
            "Outros"
        ],
        "Type": "Outros"
    },
    {
        "title": "Anny Calçados",
        "description": "Calçados femininos no varejo",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/002/395/560/themes/common/logo-1943692536-1685584365-74a63c2c2a9c950d59807f6d78632b3a1685584365.jpg?0",
        "client": "Anny Calçados",
        "url": "https://links.parceirando.com.br/marketing/4492",
        "comission": "Fixado R$",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4492",
        "categories": [
            "Outros"
        ],
        "Type": "Outros"
    },
    {
        "title": "Sens de L'air",
        "description": "Nossa coleção de velas aromáticas, difusores de ambientes e home sprays proporcionam uma experiência olfativa única. Dedicados a oferecer produtos com personalidade atemporal e elegante, transformamos qualquer espaço em um ambiente acolhedor e envolvente através de fragrâncias únicas. Descubra como nossos produtos podem adicionar um toque especial à sua casa ou ambiente de trabalho e mergulhe em uma jornada sensorial inesquecível!",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/003/181/811/themes/common/logo-653554197-1699555949-17d8ee3c1a028a17f0ec790cdc3003001699555949.png?0",
        "client": "Sens de L'air",
        "url": "https://links.parceirando.com.br/marketing/4714",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4714",
        "categories": [
            "Perfumes",
            "Outros"
        ],
        "Type": "Perfumes"
    },
    {
        "title": "Ekoa Educação",
        "description": "E-commerce para Cursos e Livros voltados Desenvolvimento Técnico Profissional e Concursos.",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4718/4718.png",
        "client": "Ekoa Educação",
        "url": "https://links.parceirando.com.br/marketing/4718",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4718",
        "categories": [
            "Outros"
        ],
        "Type": "Outros"
    },
    {
        "title": "Maria Panela",
        "description": "Maria Panela, Utilidades e Presentes ",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/001/576/065/themes/common/logo-1002289569-1702155054-746787094ce9a4f07083c76c0126040d1702155055.png?0",
        "client": "Maria Panela",
        "url": "https://links.parceirando.com.br/marketing/4865",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4865",
        "categories": [
            "Outros"
        ],
        "Type": "Outros"
    },
    {
        "title": "FutHype | Artigos Esportivos",
        "description": "Na FutHype temos uma vasta coleção de camisas de times. De clássicos icônicos a lançamentos exclusivos, cada peça uma expressão de estilo e paixão pelo esporte. Seja parte parte da nossa equipe, seja FutHype.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/031/447/themes/common/logo-1298555481-1702213231-367c13fc32c142f05080d3210d4dc0041702213232.png?0",
        "client": "FutHype | Artigos Esportivos",
        "url": "https://links.parceirando.com.br/marketing/5059",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/5059",
        "categories": [
            "Outros"
        ],
        "Type": "Outros"
    },
    {
        "title": "Cazachic Home Decor",
        "description": "Encontre almofadas, mantas e enxovais encantadores para decorar sua casa. Explore nossa seleção exclusiva de artigos de mesa posta e decoração para transformar seus momentos especiais em experiências inesquecíveis. Renove seu lar com estilo e qualidade, só na Cazachic!",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/001/035/509/themes/common/logo-825468811-1672251878-126a1a7b279b7e131dfc1c972caa61061672251878.png?0",
        "client": "Cazachic Home Decor",
        "url": "https://links.parceirando.com.br/marketing/4903",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4903",
        "categories": [
            "Casas e Móveis",
            "Outros"
        ],
        "Type": "Casas e Móveis"
    },
    {
        "title": "TKS Farinhas de Trigo",
        "description": "Farinhas de Trigo, Sêmolas e Pomodoro Italiano",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4868/4868.png",
        "client": "TKS Farinhas de Trigo",
        "url": "https://links.parceirando.com.br/marketing/4868",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4868",
        "categories": [
            "Outros"
        ],
        "Type": "Outros"
    },
    {
        "title": "Momento Mágico Personalizado",
        "description": "Canecas personalizadas, copos termicos personalizados em gravação a laser. Brindes Corporativos",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/699/421/themes/common/logo-1100299612-1716146904-809e69b5600e216ac2eceae86e6f75e31716146905.jpg?0",
        "client": "Momento Mágico Personalizado",
        "url": "https://links.parceirando.com.br/marketing/5008",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/5008",
        "categories": [
            "Outros"
        ],
        "Type": "Outros"
    },
    {
        "title": "QUINTAESENCIA FRAGANCIAS",
        "description": "Especialista en perfumeria de contratipo",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4181/4181.png",
        "client": "QUINTAESENCIA FRAGANCIAS",
        "url": "https://links.parceirando.com.br/marketing/4181",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4181",
        "categories": [
            "Cosméticos"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "WESS PROFESSIONAL",
        "description": "Cosméticos Profissionais",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/1977/1977.png",
        "client": "WESS PROFESSIONAL",
        "url": "https://links.parceirando.com.br/marketing/1977",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/1977",
        "categories": [
            "Cosméticos"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "Victoria Hair Cosméticos",
        "description": "Os melhores produtos de beleza do mercado",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/001/359/685/themes/common/logo-744075100-1692979628-4de19093b96c23d4bddb4b876f3d595e1692979628.png?0",
        "client": "Victoria Hair Cosméticos",
        "url": "https://links.parceirando.com.br/marketing/1674",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/1674",
        "categories": [
            "Cosméticos"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "Plancton Produtos Cosmeticos",
        "description": "Cosméticos Capilares .",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/001/121/012/themes/common/logo-983328374-1701456343-d94eebfa9406cf80ea002f46920613781701456343.png?0",
        "client": "Plancton Produtos Cosmeticos",
        "url": "https://links.parceirando.com.br/marketing/1727",
        "comission": "Fixado R$",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/1727",
        "categories": [
            "Cosméticos"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "nantie",
        "description": "Cosméticos veganos, multifuncionais, com ativos naturais e cruelty free",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/001/859/079/themes/common/logo-1387602070-1631205634-e2112456622a53e5ca8f98b1249467bf1631205634.png?0",
        "client": "nantie",
        "url": "https://links.parceirando.com.br/marketing/4926",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4926",
        "categories": [
            "Cosméticos"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "Tresso Cosmetics",
        "description": "Comercializamos cosméticos capilares ",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4352/4352.png",
        "client": "Tresso Cosmetics",
        "url": "https://links.parceirando.com.br/marketing/4352",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4352",
        "categories": [
            "Cosméticos"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "VIZBELLE COSMETICOS LTDA",
        "description": "Produtos Cosméticos",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/001/113/940/themes/common/logo-181560157-1689869374-84cbcb0e84224bd85310a8b3973f03f81689869374.jpg?0",
        "client": "VIZBELLE COSMETICOS LTDA",
        "url": "https://links.parceirando.com.br/marketing/1776",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/1776",
        "categories": [
            "Cosméticos"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "Tekmi ",
        "description": "Tekmi Cosméticos ",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/001/196/745/themes/common/logo-731734838-1657894879-6a41d27ebe7c9e00ef1209a5b5737d501657894880.png?0",
        "client": "Tekmi ",
        "url": "https://links.parceirando.com.br/marketing/3373",
        "comission": "Fixado R$",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/3373",
        "categories": [
            "Cosméticos"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "Karseell Original",
        "description": "Cosméticos.",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4823/4823.png",
        "client": "Karseell Original",
        "url": "https://links.parceirando.com.br/marketing/4823",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4823",
        "categories": [
            "Cosméticos"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "Ale Diversos Ltda",
        "description": "Venha agora mesmo conhecer o melhores produtos de cometicos e ainda mais podendo fazer uma renda extra e tendo beneficios em nossa loja venha agora mesm adquirir o seu produto tanto para homem quanto para mulher",
        "image": "https://parceirando.s3.amazonaws.com/media/landing/404.webp",
        "client": "Ale Diversos Ltda",
        "url": "https://links.parceirando.com.br/marketing/5038",
        "comission": "Fixado R$",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/5038",
        "categories": [
            "Cosméticos",
            "Perfumes"
        ],
        "Type": "Cosméticos"
    },
    {
        "title": "LOOTY COMERCIO DE PERFUMES EIRELI EPP",
        "description": "Perfumes Inspirados em Fragrâncias Famosas",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/004/184/402/themes/common/logo-22074230-1706386251-8a242b9d2a32734c8fef0fcffa65ad261706386251.jpg?0",
        "client": "LOOTY COMERCIO DE PERFUMES EIRELI EPP",
        "url": "https://links.parceirando.com.br/marketing/4645",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4645",
        "categories": [
            "Perfumes"
        ],
        "Type": "Perfumes"
    },
    {
        "title": "Primacial",
        "description": "Fragrâncias",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/002/871/143/themes/common/logo-301939084-1677156468-6d3b422a24cb54ca4547a27c2b7c33691677156469.png?0",
        "client": "Primacial",
        "url": "https://links.parceirando.com.br/marketing/4970",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4970",
        "categories": [
            "Perfumes"
        ],
        "Type": "Perfumes"
    },
    {
        "title": "ofertasna",
        "description": "Perfumes amostras miniaturas tester produtos de beleza ",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/881/402/themes/common/logo-1767993453-1543346188-63f7b27d59992e56e6b61bac3bb93a8a1543346188.jpg?0",
        "client": "ofertasna",
        "url": "https://links.parceirando.com.br/marketing/4537",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4537",
        "categories": [
            "Perfumes"
        ],
        "Type": "Perfumes"
    },
    {
        "title": "The Candle Store",
        "description": "Fragrancias para ambientes ",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/003/041/278/themes/common/logo-1811470753-1681481357-6c3ae940d71824bb991c2be8e4a317b51681481357.png?0",
        "client": "The Candle Store",
        "url": "https://links.parceirando.com.br/marketing/4626",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4626",
        "categories": [
            "Perfumes"
        ],
        "Type": "Perfumes"
    },
    {
        "title": "SG Perfumes e Decants Importados",
        "description": "Site especializado em perfumes importados originais em decants",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/001/078/255/themes/common/logo-1598553816-1574425214-260fc10a70f2b8aabd735e216d3f37701574425214.png?0",
        "client": "SG Perfumes e Decants Importados",
        "url": "https://links.parceirando.com.br/marketing/4256",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4256",
        "categories": [
            "Perfumes"
        ],
        "Type": "Perfumes"
    },
    {
        "title": "Arara Rosa - Perfume&Casa",
        "description": "Perfumes para ambientes. ",
        "image": "https://parceirando-minisite-images.s3.amazonaws.com/site/4762/4762.png",
        "client": "Arara Rosa - Perfume&Casa",
        "url": "https://links.parceirando.com.br/marketing/4762",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4762",
        "categories": [
            "Casas e Móveis",
            "Perfumes"
        ],
        "Type": "Casas e Móveis"
    },
    {
        "title": "Loja Amo Paraiso",
        "description": "Somos um grupo de moda bebê e infantile possuímos 3 marcas próprias: Paraiso, Le bhua e Letut. Vendemos roupas para bebês e crianças de 0 a 10 anos.",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/002/670/737/themes/common/logo-1631539495-1671284300-1cb17ed24f7abdb0ddb184dcff000f491671284301.png?0",
        "client": "Loja Amo Paraiso",
        "url": "https://links.parceirando.com.br/marketing/4666",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4666",
        "categories": [
            "Infantil/Bebês"
        ],
        "Type": "Infantil/Bebês"
    },
    {
        "title": "Mundo Tematicos Afiliados ",
        "description": "Bem-vindo ao universo encantado das roupas infantis temáticas, onde a diversão e a moda se encontram! Na nossa loja de afiliados, vestimos os pequenos com o que há de mais mágico e estiloso no mundo da moda infantil. De super-heróis a princesas, de dinossauros a unicórnios, temos uma variedade incrível de roupas que vão fazer os olhos dos pequenos brilharem e os corações dos pais derreterem",
        "image": "//d2r9epyceweg5n.cloudfront.net/stores/002/943/828/themes/common/logo-1024557452-1698070004-483421e3730037ce85d0cba628fbefa31698070005.png?0",
        "client": "Mundo Tematicos Afiliados ",
        "url": "https://links.parceirando.com.br/marketing/4570",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/4570",
        "categories": [
            "Infantil/Bebês"
        ],
        "Type": "Infantil/Bebês"
    },
    {
        "title": "Loja Florir",
        "description": "Canecas Criativas",
        "image": "https://d2r9epyceweg5n.cloudfront.net/stores/990/516/themes/common/logo-1692602747-1694612253-ccf17fea38e63a4c8c8da923e36533e61694612253.png?0",
        "client": "Loja Florir",
        "url": "https://links.parceirando.com.br/marketing/2379",
        "comission": "%",
        "affiliationLink": "https://www.parceirando.com.br/affiliate/external/create/2379",
        "categories": [
            "Casas e Móveis"
        ],
        "Type": "Casas e Móveis"
    }
]

const categories = [
    { id: 0, name: 'Todas', speciality: 'bundle.speciality0' },
    { id: 1, name: 'Bebidas', speciality: 'bundle.speciality1' },
    { id: 2, name: 'Casas e Móveis', speciality: 'bundle.speciality2' },
    { id: 3, name: 'Cosméticos', speciality: 'bundle.speciality3' },
    { id: 4, name: 'Entretenimento', speciality: 'bundle.speciality4' },
    { id: 5, name: 'Games', speciality: 'bundle.speciality5' },
    { id: 6, name: 'Infantil/Bebês', speciality: 'bundle.speciality6' },
    { id: 7, name: 'Informática', speciality: 'bundle.speciality7' },
    { id: 8, name: 'Moda e Acessórios', speciality: 'bundle.speciality8' },
    { id: 9, name: 'Perfumes', speciality: 'bundle.speciality9' },
    { id: 10, name: 'Pet', speciality: 'bundle.speciality10' },
    { id: 11, name: 'Saúde', speciality: 'bundle.speciality11' },
    { id: 12, name: 'Sexshop', speciality: 'bundle.speciality12' },
    { id: 14, name: 'Suplementos', speciality: 'bundle.speciality14' },
    { id: 13, name: 'Outros', speciality: 'bundle.speciality13' }
];


export const siteService = {
    getSites: async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PARCEIRANDO_LANDING_SITES}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${process.env.REACT_APP_API_TOKEN}`
                }
            })

            const sites = await response.json()
            if (sites) {
                products = sites
            }
        } catch (error) {
            console.log(error)
        }
        let filterProducts = [];
        for (let index = 0; index < categories.length; index++) {
            const category = categories[index];
            for (let index = 0; index < products.length; index++) {
                const product = products[index];
                if (product.categories.includes(category?.name)) {
                    delete product.categories
                    product.categories = [];
                    product.categories.push(category?.name)
                    if (!filterProducts.includes(product)) {
                        filterProducts.push(product);
                    }
                }
            }
        }
        return filterProducts.sort(() => 0.5 - Math.random());
    }
};